
import { Link, useLocation } from "react-router-dom";
import { motion, AnimatePresence } from "framer-motion";
import { cn } from "@/lib/utils";
import { Button } from "@/components/ui/button";
import { Phone } from "lucide-react";
import { NavItemProps } from "./NavItems";
import ContactInfo from "./ContactInfo";
import ConsultationButton from "./ConsultationButton";

interface MobileMenuProps {
  isOpen: boolean;
  navLinks: NavItemProps[];
}

const MobileMenu = ({ isOpen, navLinks }: MobileMenuProps) => {
  const location = useLocation();

  return (
    <AnimatePresence>
      {isOpen && (
        <motion.div
          initial={{ opacity: 0, height: 0 }}
          animate={{ opacity: 1, height: "auto" }}
          exit={{ opacity: 0, height: 0 }}
          transition={{ duration: 0.3 }}
          className="md:hidden overflow-hidden"
        >
          <div className="bg-background/98 backdrop-blur-lg shadow-lg py-4 border-t border-accent/15">
            <div className="page-container">
              <div className="max-h-[70vh] overflow-y-auto scrollbar-none">
                <nav className="flex flex-col space-y-1">
                  {navLinks.map((link) => 
                    link.dropdown ? (
                      <div key={link.name} className="space-y-1">
                        <div className="px-3 py-2 font-medium text-sm flex items-center border-b border-border/30">
                          {link.icon && link.icon}
                          {link.name}
                        </div>
                        <div className="space-y-1 mb-3">
                          {link.items?.map((item) => (
                            <Link
                              key={item.name}
                              to={item.path}
                              className={cn(
                                "block px-4 py-2 rounded-md text-sm transition-colors",
                                location.pathname === item.path
                                  ? "bg-accent/15 text-accent"
                                  : "hover:bg-muted"
                              )}
                            >
                              <div className="font-medium">{item.name}</div>
                              <div className="text-xs text-muted-foreground">{item.description}</div>
                            </Link>
                          ))}
                        </div>
                      </div>
                    ) : (
                      <Link
                        key={link.path}
                        to={link.path}
                        className={cn(
                          "px-4 py-3 rounded-md font-medium text-sm transition-colors flex items-center",
                          link.className,
                          location.pathname === link.path
                            ? "bg-accent/15 text-accent"
                            : "hover:bg-muted"
                        )}
                        onClick={link.onClick}
                      >
                        {link.icon && link.icon}
                        {link.name}
                      </Link>
                    )
                  )}
                </nav>
              </div>
              <div className="mt-4 px-4 pt-4 border-t border-border/40">
                <ContactInfo className="mb-4" />
                <ConsultationButton fullWidth />
              </div>
            </div>
          </div>
        </motion.div>
      )}
    </AnimatePresence>
  );
};

export default MobileMenu;
